import React, { useEffect, useState } from 'react';
import API from '../../pages/Api';
import { 
    FaEnvelope, FaPaperPlane, FaPaperclip, FaTimes, 
    FaFilePdf, FaImage, FaVideo, FaFileAlt 
} from 'react-icons/fa';
import { toast } from 'react-toastify';
import TableContainer from '../common/Tablecontainer';

const Chat = () => {
    const [queries, setQueries] = useState([]);
    const [selectedQuery, setSelectedQuery] = useState(null);
    const [messages, setMessages] = useState([]);
    const [newMessage, setNewMessage] = useState('');
    const [file, setFile] = useState(null);
    const [filePreview, setFilePreview] = useState(null); 
    const [loading, setLoading] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');

    useEffect(() => { fetchQueries(); }, []);

    const fetchQueries = async () => {
        setLoading(true);
        try {
            const res = await API.get('query-list/');
            setQueries(res.data);
        } catch (error) {
            console.error("Error fetching queries:", error);
        } finally {
            setLoading(false);
        }
    };

    
    const filteredQueries = queries.filter(item => 
        item.Name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item.AmtDesc?.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item.mobileno?.toLowerCase().includes(searchQuery.toLowerCase())
    );

    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        if (selectedFile) {
            setFile(selectedFile);
            setFilePreview(URL.createObjectURL(selectedFile));
        }
    };

    const openChat = async (query) => {
        setSelectedQuery(query);
        try {
            const res = await API.get(`chat/${query.queryId}/`);
            setMessages(res.data.userChats); 
        } catch (error) {
            console.error("Error fetching chat:", error);
        }
    };

    const sendMessage = async () => {
        if (!newMessage.trim() && !file) return;

        const formData = new FormData();
        formData.append('queryId', selectedQuery.queryId);
        formData.append('QueryAnswered', newMessage);
        if (file) formData.append('file_attachment', file);

        try {
            await API.post('ReplyQueryDtls/', formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            setNewMessage('');
            setFile(null);
            setFilePreview(null);
            if(document.getElementById('file-input')) document.getElementById('file-input').value = '';
            openChat(selectedQuery); 
        } catch (error) {
            console.error("Error:", error);
            toast.error("Error sending message.");
        }
    };

    return (
        <div className="p-2
        md:p-6
        bg-[#F8FAFC]
        min-h-screen
        w-full
        max-w-full
        overflow-x-hidden
        box-border
        flex
        flex-col
        items-center
        font-sans">
            <h2 className="text-center text-4xl font-light text-gray-700 mb-8 tracking-tight">Query Details</h2>
            <div className="hidden md:block">
            <TableContainer 
                columns={[ 'User Name', 'Course', 'Mobile No.', 'View']}
                data={filteredQueries} 
                loading={loading}
                searchQuery={searchQuery}
                setSearchQuery={setSearchQuery} 
                searchPlaceholder="Search by name, course or mobile..."
                renderRow={(q, i, srNo) => (
                    <tr key={q.queryId} className="border-b border-gray-200 hover:bg-gray-50 text-center text-xs">
                        <td className="p-3 border-r font-bold text-gray-500">{srNo}</td>
                        <td className="p-3 border-r font-semibold text-left text-gray-800">{q.Name}</td>
                        <td className="p-3 border-r font-semibold text-left text-gray-800">{q.AmtDesc}</td>
                        <td className="p-3 border-r font-semibold text-gray-800">{q.mobileno}</td>
                        <td className="p-3 border-r font-semibold text-gray-800">
                            <button onClick={() => openChat(q)} className="text-[#032167] hover:scale-110 transition-transform">
                                <FaEnvelope size={20}/>
                            </button>
                        </td>
                    </tr>
                )}
            />
            </div>

            <div className="md:hidden mt-4 space-y-4 w-full overflow-x-hidden">

                {loading ? (

                    <div className="text-center py-10">
                        Loading...
                    </div>

                ) : filteredQueries.length === 0 ? (

                    <div className="text-center py-10 text-gray-500">
                        No Records Found
                    </div>

                ) : (

                    filteredQueries.map((q) => (

                        <div
                            key={q.queryId}
                            className="
                            bg-white
                            rounded-xl
                            border
                            shadow-sm
                            p-4
                            w-full
                            max-w-full
                            overflow-hidden
                            "
                        >

                            <div className="space-y-3">

                                <div>
                                    <p className="text-xs text-gray-500">
                                        User
                                    </p>

                                    <p className="font-semibold break-words overflow-hidden">
                                        {q.Name}
                                    </p>
                                </div>

                                <div>
                                    <p className="text-xs text-gray-500">
                                        Course
                                    </p>

                                    <p className="break-words">
                                        {q.AmtDesc}
                                    </p>
                                </div>

                                <div>
                                    <p className="text-xs text-gray-500">
                                        Mobile
                                    </p>

                                    <p className="break-all">
                                        {q.mobileno}
                                    </p>
                                </div>

                                <div className="flex justify-end">

                                    <button
                                        onClick={() => openChat(q)}
                                        className="
                                        bg-[#032167]
                                        text-white
                                        px-4
                                        py-2
                                        rounded-lg
                                        "
                                    >
                                        Open Chat
                                    </button>

                                </div>

                            </div>

                        </div>

                    ))

                )}

            </div>

            {/* Chat Modal */}
            {selectedQuery && (
                <div
                className="
                fixed
                inset-0
                z-[99999]
                bg-black/60
                flex
                items-center
                justify-center
                p-1
                md:p-6
                overflow-hidden
                overflow-x-hidden
                "
                >
                    <div
                    className="
                    w-full
                    max-w-full
                    md:max-w-2xl
                    h-[75vh] 
                    md:h-[80vh]
                    
                    px-1
                    "
                    >
                        <div
                        className="
                        bg-white
                        w-full
                        h-full
                        rounded-xl
                        md:rounded-2xl
                        shadow-2xl
                        flex
                        flex-col
                        overflow-hidden
                        "
                        >
                        <div className="
                        bg-[#64a106]
                        text-white
                        px-4
                        min-h-[60px]
                        flex
                        justify-between
                        items-center
                        flex-shrink-0
                        ">
                            <h3
                            className="
                            font-bold
                            text-base
                            md:text-lg
                            truncate
                            pr-2
                            "
                            >Chat: {selectedQuery.Name}</h3>
                            <button onClick={() => setSelectedQuery(null)} className="hover:bg-white/20 p-1 rounded-full"><FaTimes/></button>
                        </div>
                        
                        <div
                        className="
                        flex-1
                        overflow-y-auto
                        overflow-x-hidden
                        max-h-[50vh]
                        min-h-0
                        bg-[#f4f5f7]
                        p-2
                        md:p-3
                        space-y-2
                        "
                        >

                            
                            {messages.map((m, idx) => (
                                <div key={idx} className={`flex flex-col ${m.UserType === "2" ? 'items-end' : 'items-start'}`}>
                                    <div
                                    className={`
                                    max-w-[85%]
                                    md:max-w-[72%]
                                    overflow-hidden
                                    px-3
                                    py-2
                                    rounded-xl
                                    shadow-sm
                                    break-words
                                    ${
                                    m.UserType==="2"
                                    ?
                                    "bg-[#003366] text-white"
                                    :
                                    "bg-white text-gray-800"
                                    }
                                    `}
                                    >
                                        <p
                                        className="
                                        text-sm
                                        leading-6
                                        break-words
                                        "
                                        >{m.UserQuery || m.QueryAnswered}</p>
                                        {m.file_attachment && (
                                            <a
                                                href={`${process.env.REACT_APP_MEDIA_URL || 'https://tgsh.geometricsoft.com'}/media/${m.file_attachment}`}
                                                target="_blank"
                                                rel="noreferrer"
                                                className="
                                                    flex
                                                    items-center
                                                    gap-2
                                                    text-xs
                                                    mt-2
                                                    max-w-full
                                                    overflow-hidden
                                                "
                                            >
                                                {m.file_attachment.toLowerCase().endsWith('.pdf') ? (
                                                    <FaFilePdf className="text-red-500 shrink-0" />
                                                ) : m.file_attachment.toLowerCase().match(/\.(jpg|jpeg|png|gif)$/) ? (
                                                    <FaImage className="text-green-500 shrink-0" />
                                                ) : m.file_attachment.toLowerCase().match(/\.(mp4|mov|avi)$/) ? (
                                                    <FaVideo className="text-purple-500 shrink-0" />
                                                ) : (
                                                    <FaFileAlt className="text-gray-500 shrink-0" />
                                                )}

                                                <span
                                                className="
                                                font-medium
                                                truncate
                                                overflow-hidden
                                                whitespace-nowrap
                                                max-w-[170px]
                                                block
                                                "
                                                title={m.file_attachment.split("/").pop()}
                                                >
                                                    📄 {m.file_attachment.split("/").pop()}
                                                </span>
                                            </a>
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>

                        <div
                        className="
                        border-t
                        bg-white
                        px-3
                        py-2
                        p-3
                        flex-shrink-0
                        "
                        >
                            {filePreview && (
                                <div className="p-2 mb-2 bg-gray-100 flex justify-between text-xs rounded border">
                                    <span>{file?.name}</span>
                                    <button onClick={() => {setFile(null); setFilePreview(null);}} className="text-red-500 font-bold">X</button>
                                </div>
                            )}
                            <div
                            className="
                            flex
                            items-center
                            gap-2
                            "
                            >
                                <label className="cursor-pointer text-gray-500 hover:text-[#032167]">
                                    <div
                                    className="
                                    w-12
                                    h-12
                                    rounded-full
                                    flex
                                    items-center
                                    justify-center
                                    hover:bg-gray-100
                                    "
                                    >
                                    <FaPaperclip size={18}/>
                                    </div>
                                    <input id="file-input" type="file" className="hidden" onChange={handleFileChange}/>
                                </label>
                                <input value={newMessage} onChange={e => setNewMessage(e.target.value)} className="
                                flex-1
                                min-w-0
                                h-11
                                px-4
                                border
                                rounded-full
                                text-sm
                                outline-none
                                " placeholder="Type a reply..." />
                                <button onClick={sendMessage} className="
                                bg-[#032167]
                                text-white
                                w-12
                                h-12
                                rounded-full
                                flex
                                items-center
                                justify-center
                                flex-shrink-0
                                hover:bg-blue-900
                                transition
                                "><FaPaperPlane/></button>
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};
export default Chat;